export function isValidServingsPerContainer(value: unknown): boolean {
  if (value === "" || value === null || value === undefined) {
    return true;
  }

  return typeof value === "number" && Number.isFinite(value) && value >= 0;
}

export function normalizeServingsPerContainer(value: unknown): number {
  const parsedValue = typeof value === "number" ? value : Number(value);

  return Number.isFinite(parsedValue) && parsedValue >= 0 ? parsedValue : 0;
}

export function normalizeHouseholdMeasure(value: unknown): string {
  return typeof value === "string" ? value : "";
}
